import type {FC, HTMLAttributes} from 'react'
import type React from 'react'
import {GrabberIcon} from '@primer/octicons-react'
import {IconButton, Box} from '@primer/react'
import {useSortable} from '@dnd-kit/sortable'
import {useSortableItem} from '../hooks/use-sortable-item'
import {testIdProps} from '@github-ui/test-id-props'

export interface SortableListItemProps extends Omit<HTMLAttributes<HTMLButtonElement>, 'id' | 'aria-labelledby'> {}

export const SortableListTrigger: FC<React.PropsWithChildren<SortableListItemProps>> = ({...props}) => {
  const {title, id} = useSortableItem()
  const {setActivatorNodeRef, listeners, isDragging} = useSortable({
    id,
    data: {metadata: {id}},
  })

  const {onMouseDown, onClick, onKeyDown} = listeners as {
    onMouseDown: React.MouseEventHandler
    onClick: React.MouseEventHandler
    onKeyDown: React.KeyboardEventHandler
  }

  return (
    <Box className="sortable-trigger" sx={{display: 'flex', position: 'relative'}}>
      <Box onMouseDown={onMouseDown} sx={{position: 'absolute', width: '100%', height: '100%', cursor: 'grab'}} />
      <IconButton
        sx={{p: 1, cursor: 'grab', mr: 1}}
        aria-label={`Move ${title}`}
        ref={setActivatorNodeRef}
        onKeyDown={onKeyDown}
        onClick={onClick}
        variant="invisible"
        role={isDragging ? 'application' : 'button'}
        icon={GrabberIcon}
        {...props}
        {...testIdProps('sortable-trigger')}
      />
    </Box>
  )
}

try{ SortableListTrigger.displayName ||= 'SortableListTrigger' } catch {}